import { render, staticRenderFns } from "./P1-2.vue?vue&type=template&id=26a93b8d&scoped=true"
import script from "./P1-2.vue?vue&type=script&lang=js"
export * from "./P1-2.vue?vue&type=script&lang=js"
import style0 from "./P1-2.vue?vue&type=style&index=0&id=26a93b8d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a93b8d",
  null
  
)

export default component.exports